<template>
  <div class="detail">
    <el-card style="margin-bottom: 15px">
      <table>
        <tbody>
          <div class="divitem" v-if="formDataInfo1.formData.citizen == 'true'">
            <div class="title">申请人类型</div>
            <div>公民</div>
            <div class="title">姓名</div>
            <div>{{ formDataInfo1.formData.name }}</div>
          </div>
          <div class="divitem" v-else>
            <div class="title">申请人类型</div>
            <div>法人/其他组织</div>
            <div class="title">名称</div>
            <div>{{ formDataInfo1.formData.corporateName }}</div>
          </div>
          <div class="divitem" v-if="formDataInfo1.formData.citizen == 'true'">
            <div class="title">工作单位</div>
            <div>{{ formDataInfo1.formData.workUnit }}</div>
            <div class="title">通讯地址</div>
            <div>{{ formDataInfo1.formData.mailAddress }}</div>
          </div>
          <div class="divitem" v-else>
            <div class="title">组织机构代码</div>
            <div>{{ formDataInfo1.formData.orgCode }}</div>
            <div class="title">营业执照</div>
            <div>{{ formDataInfo1.formData.businessLicense }}</div>
          </div>
          <div class="divitem" v-if="formDataInfo1.formData.citizen == 'true'">
            <div class="title">证件名称</div>
            <div>{{ formDataInfo1.formData.idType }}</div>
            <div class="title">证件号码</div>
            <div>{{ formDataInfo1.formData.idNo }}</div>
          </div>
          <div class="divitem" v-else>
            <div class="title">联系人姓名</div>
            <div>{{ formDataInfo1.formData.name }}</div>
            <div class="title">联系人电话</div>
            <div>{{ formDataInfo1.formData.phone }}</div>
          </div>
          <div class="divitem" v-if="formDataInfo1.formData.citizen == 'true'">
            <div class="title">手机号码</div>
            <div>{{ formDataInfo1.formData.phone }}</div>
            <div class="title">邮政编码</div>
            <div>{{ formDataInfo1.formData.postalCode }}</div>
          </div>
          <div class="divitem" v-else>
            <div class="title">法定代表人</div>
            <div>{{ formDataInfo1.formData.legalRepresentative }}</div>
            <div class="title">通讯地址</div>
            <div>{{ formDataInfo1.formData.mailAddress }}</div>
          </div>
          <div class="divitem">
            <div class="title">传真</div>
            <div>{{ formDataInfo1.formData.fax }}</div>
            <div class="title">电子邮箱</div>
            <div>{{ formDataInfo1.formData.email }}</div>
          </div>
          <div class="divitem">
            <div class="title">申请时间</div>
            <div>{{ formDataInfo1.formData.createTime }}</div>
            <div class="title">身份证正面</div>
            <div>
              <a
                :href="formDataInfo1.formData.frontSide"
                target="_blank"
                style="
                  color: blue !important;
                  text-decoration: underline !important;
                "
                >身份证正面图片</a
              >
            </div>
          </div>
          <div class="divitem">
            <div class="title">附件</div>
            <div>
              <a
                style="
                  margin-right: 20px;
                  color: blue !important;
                  text-decoration: underline !important;
                "
                v-for="(item, index) in fjArr"
                :key="index"
                :href="item"
                target="_blank"
                >附件{{ index + 1 }}</a
              >
            </div>
            <div class="title">身份证反面</div>
            <div>
              <a
                :href="formDataInfo1.formData.backSide"
                target="_blank"
                style="
                  color: blue !important;
                  text-decoration: underline !important;
                "
                >身份证反面图片</a
              >
            </div>
          </div>
          <div class="divitem">
            <div class="title">所需信息内容描述</div>
            <div>{{ formDataInfo1.formData.description }}</div>
            <div class="title">所需信息用途描述</div>
            <div></div>
          </div>
          <div class="divitem">
            <div class="title">是否申请减免费用</div>
            <div></div>
            <div class="title">信息指定提供方式</div>
            <div></div>
          </div>
          <div class="divitem">
            <div class="title" style="height: 80px">信息的获取方式</div>
            <div>
              {{
                formDataInfo1.formData.obtainMethod == "1"
                  ? "邮寄"
                  : formDataInfo1.formData.obtainMethod == "2"
                  ? "电子邮件"
                  : formDataInfo1.formData.obtainMethod == "3"
                  ? "当面领取"
                  : formDataInfo1.formData.obtainMethod == "4"
                  ? "现场查阅"
                  : "系统查收"
              }}
            </div>
            <div
              class="title"
              style="padding: 0 14px; box-sizing: border-box; height: 80px"
            >
              若本机关无法按照指定方式 提供所需信息，也可接收其 他方式；
            </div>
            <div>
              {{ formDataInfo1.formData.otherMethod == "true" ? "是" : "否" }}
            </div>
          </div>
          <div class="divitem">
            <div class="title">办件编号</div>
            <div>{{ formDataInfo1.formData.taskNo }}</div>
            <div class="title">提交对象</div>
            <div>{{ formDataInfo1.formData.submit }}</div>
          </div>
          <div class="divitem" v-if="showLc == 5">
            <div class="title">撤销时间</div>
            <div>{{ formDataInfo1.formData.revokeTime }}</div>
            <div class="title">撤销原因</div>
            <div>{{ formDataInfo1.formData.revokeReason }}</div>
          </div>
        </tbody>
      </table>
      <div class="lc">
        <div class="left" v-if="showLc != 3 && showLc != 6 && showLc != 5">
          <span style="position: absolute; left: 355px; top: 12px; color: #fff"
            >流程跟踪</span
          >
          <img class="img1" src="../../assets/img/liuchengxian.png" alt="" />
          <div class="con con1">
            {{ formDataInfo1.formData.createTime }} 前台用户
            <span style="color: #82a864">申请</span>
          </div>
          <img class="img2" src="../../assets/img/shenqing.png" alt="" />
          <div class="con con2">
            等待 {{ formDataInfo1.formData.submit }}审核员<span
              style="color: #c44b4b"
            >
              办理</span
            >
          </div>
          <img class="img3" src="../../assets/img/shenpi.png" alt="" />
          <div class="con con3"></div>
          <img class="img4" src="../../assets/img/zu7.png" alt="" />
          <ul class="flag">
            <li>
              <img src="../../assets/img/shenqing.png" alt="" />已处理环节
            </li>
            <li>
              <img src="../../assets/img/shenpi.png" alt="" />正在处理环节
            </li>
            <li><img src="../../assets/img/zu7.png" alt="" />下一环节</li>
          </ul>
        </div>
        <div class="left" v-if="showLc == 3 || showLc == 5">
          <span style="position: absolute; left: 355px; top: 12px; color: #fff"
            >流程跟踪</span
          >
          <img class="img1" src="../../assets/img/liuchengxian.png" alt="" />
          <div class="con con1">
            {{ formDataInfo1.formData.createTime }} 前台用户
            <span style="color: #82a864">申请</span>
          </div>
          <img class="img2" src="../../assets/img/shenqing.png" alt="" />
          <div class="con con2">
            {{ formDataInfo1.formData.submit }}审核员
            <span style="color: #82a864">通过</span>
          </div>
          <img class="img3" src="../../assets/img/shenqing.png" alt="" />
          <div class="con con3">
            流程已办理结束 <span style="color: #82a864">请查收</span>
          </div>
          <img class="img4" src="../../assets/img/shenqing.png" alt="" />
          <ul class="flag">
            <li>
              <img src="../../assets/img/shenqing.png" alt="" />已处理环节
            </li>
            <li>
              <img src="../../assets/img/shenpi.png" alt="" />正在处理环节
            </li>
            <li><img src="../../assets/img/zu7.png" alt="" />下一环节</li>
          </ul>
        </div>
        <div class="left" v-if="showLc == 6">
          <span style="position: absolute; left: 355px; top: 12px; color: #fff"
            >流程跟踪</span
          >
          <img class="img1" src="../../assets/img/liuchengxian.png" alt="" />
          <div class="con con1">
            {{ formDataInfo1.formData.createTime }} 前台用户
            <span style="color: #82a864">申请</span>
          </div>
          <img class="img2" src="../../assets/img/shenqing.png" alt="" />
          <div class="con con2">
            {{ formDataInfo1.formData.submit }}审核员
            <span style="color: #82a864">不通过</span>
          </div>
          <img class="img3" src="../../assets/img/shenqing.png" alt="" />
          <div class="con con3">
            流程已办理结束 <span style="color: #82a864">请查收</span>
          </div>
          <img class="img4" src="../../assets/img/shenqing.png" alt="" />
          <ul class="flag">
            <li>
              <img src="../../assets/img/shenqing.png" alt="" />已处理环节
            </li>
            <li>
              <img src="../../assets/img/shenpi.png" alt="" />正在处理环节
            </li>
            <li><img src="../../assets/img/zu7.png" alt="" />下一环节</li>
          </ul>
        </div>
        <div class="right">
          <span
            style="
              position: absolute;
              left: 362px;
              top: 12px;
              color: rgb(255, 255, 255);
            "
            >流程图</span
          >
          <div class="cardCon">
            <el-card>
              <img class="jt" src="../../assets/img/jiantou.png" alt="" />
              <img src="../../assets/img/kaishi.png" alt="" />
              <div style="margin-top: 24px">开始节点</div>
              <div style="margin-top: 14px">
                {{ formDataInfo1.formData.createTime }}
              </div>
            </el-card>
            <el-card>
              <img src="../../assets/img/chulishenpi.png" alt="" />
              <img class="jt" src="../../assets/img/jiantou.png" alt="" />
              <div style="margin-top: 24px">办理节点</div>
              <div style="margin-top: 14px">
                {{
                  showLc == 3 || showLc == 6
                    ? formDataInfo2.formData.createTime
                    : "无"
                }}
              </div>
            </el-card>
            <el-card>
              <img src="../../assets/img/jieshujiedian.png" alt="" />

              <div style="margin-top: 24px">结束节点</div>
              <div style="margin-top: 14px">
                {{
                  showLc == 3 || showLc == 6
                    ? formDataInfo2.formData.createTime
                    : "无"
                }}
              </div>
            </el-card>
          </div>
          <div style="margin-top: 67px">*按照此流程图顺序完成办理</div>
        </div>
      </div>
    </el-card>
    <el-card>
      <div class="clyj">
        <div class="clyj_title">
          <span>处理意见</span>
          <img src="../../assets/img/yijian.png" alt="" />
        </div>
        <el-row
          v-if="
            formDataInfo2.formData &&
            formDataInfo2.formData.isPublic == 'true' &&
            formDataInfo2.formData.opinion
          "
          class="clyj_con"
          style="height: 180px"
        >
          <div class="noData">
            <a
              v-html="
                formDataInfo2.formData ? formDataInfo2.formData.opinion : ''
              "
            ></a>
          </div>
        </el-row>

        <el-row v-else class="clyj_con" style="height: 180px">
          <div class="noData">
            <div>
              <img src="../../assets/img/zanwuneirong.png" alt="" />
              <span>暂无内容</span>
            </div>
          </div>
        </el-row>

        <el-row
          v-if="
            formDataInfo2.formData && formDataInfo2.formData.isPublic == 'true'
          "
          class="clyj_con"
        >
          <el-col :span="8">
            <span class="t">处理人：</span
            >{{
              formDataInfo1.formData ? formDataInfo1.formData.submit : ""
            }}</el-col
          >
          <el-col :span="8">
            <span class="t">处理时间：</span
            >{{
              formDataInfo2.formData ? formDataInfo2.formData.createTime : ""
            }}
          </el-col>
          <el-col :span="8">
            <span class="t">状态：</span>公开<el-icon
              style="margin-left: 10px; color: #246aed"
              ><View /></el-icon
          ></el-col>
        </el-row>
        <div class="mes" v-if="showLc == 3">
          <span>
            <span style="color: #7db551">已通过</span>
            {{
              formDataInfo1.formData.obtainMethod == "1"
                ? "邮件"
                : formDataInfo1.formData.obtainMethod == "2"
                ? "电子邮件"
                : formDataInfo1.formData.obtainMethod == "3"
                ? "当面领取"
                : formDataInfo1.formData.obtainMethod == "4"
                ? "现场查阅"
                : "系统查收"
            }}办理</span
          >
        </div>
      </div>
      <div style="display: flex">
        <div class="clyj">
          <div class="clyj_title">
            <span>政府信息公开申请答复书</span>
            <img src="../../assets/img/fujian1.png" alt="" />
          </div>

          <el-row
            v-if="
              formDataInfo2.formData &&
              formDataInfo2.formData.annex &&
              (formDataInfo1.formData.taskState == 3 ||
                formDataInfo1.formData.taskState == 4)
            "
            style="margin-top: 15px"
          >
            <div>
              <a
                style="
                  margin-right: 20px;
                  color: blue !important;
                  text-decoration: underline !important;
                "
                v-for="(item, index) in fjArr2"
                :key="index"
                :href="item"
                target="_blank"
                >{{ formDataInfo2.formData.filename }}</a
              >
            </div>
          </el-row>
          <el-row class="clyj_con" style="height: 180px" v-else>
            <div class="noData">
              <div>
                <img src="../../assets/img/zanwuneirong.png" alt="" />
                <span>暂无内容</span>
              </div>
            </div>
          </el-row>
        </div>
        <div class="clyj" style="margin-left: 20px">
          <div class="clyj_title">
            <span>延期附件</span>
            <img src="../../assets/img/fujian1.png" alt="" />
          </div>

          <el-row
            v-if="
              formDataInfo1.formData && formDataInfo1.formData.extAttachment
            "
            style="margin-top: 15px"
          >
            <div>
              <a
                style="
                  margin-right: 20px;
                  color: blue !important;
                  text-decoration: underline !important;
                "
                :href="formDataInfo1.formData.extAttachment"
                target="_blank"
                >{{ formDataInfo1.formData.extFilename }}</a
              >
            </div>
          </el-row>
          <el-row class="clyj_con" style="height: 180px" v-else>
            <div class="noData">
              <div>
                <img src="../../assets/img/zanwuneirong.png" alt="" />
                <span>暂无内容</span>
              </div>
            </div>
          </el-row>
        </div>
      </div>
      <!-- <div style="display: flex; margin-bottom: 10px; justify-content: center">
        <el-button style="background: #246aed; color: #fff">
          <i class="iconfont icon-wenjianword">生成word</i>
        </el-button>
      </div> -->
      <div class="return" style="width: 100%">
        <img src="../../assets/img/fanhui.png" alt="" />
        <span @click="gomyPaper" style="cursor: pointer"
          >返回到<span style="color: #246aed">首页</span></span
        >
      </div>
    </el-card>
  </div>
</template>

<script setup>
import { useRoute, useRouter } from "vue-router";
import quill from "../component/quillTool/index.vue";
import { queryById } from "../../views/homepage/openflat/api";
import { onMounted, reactive, ref } from "vue";
import { ElLoading } from "element-plus";
let arr = [
  { icon: "icon-tijiaodingdan", title: "提交" },
  { icon: "icon-baocun-", title: "暂存意见" },
  { icon: "icon-zhangdanyanqiguanli", title: "延期办理" },
  { icon: "icon-wenjianword", title: "生成word" },
  { icon: "icon-chongzhijiaofei", title: "待缴费" },
  { icon: "icon-dingdanyichenggong", title: "已缴费" },
  { icon: "iconfont icon-chongzhijiaofei", title: "未缴费" },
];
let route = useRoute();
let router = useRouter();
let did = route.query.did;
var formDataInfo1 = reactive({ formData: {} });
var formDataInfo2 = reactive({ formData: {} });
var loadingInstance = reactive({});
var fjArr = reactive([]);
var fjArr2 = reactive([]);
var showLc = ref(0);
onMounted(() => {
  loadingInstance = ElLoading.service({
    lock: true,
    text: "加载中...",
    background: "rgba(0, 0, 0, 0.7)",
  });
  getInfo();
});
const gomyPaper = () => {
  console.log(123);
  router.push({
    path: "/homepage",
  });
};
const getInfo = () => {
  queryById({ id: did })
    .then((res) => {
      formDataInfo1.formData = res.applicationForm;
      formDataInfo2.formData = res.approvalInformationForm;
      console.log(typeof formDataInfo1.formData.annex);
      if (formDataInfo1.formData && formDataInfo1.formData.annex) {
        fjArr = formDataInfo1.formData.annex.split(",");
      }
      if (formDataInfo2.formData && formDataInfo2.formData.annex) {
        fjArr2 = formDataInfo2.formData.annex.split(",");
      }
      showLc.value = formDataInfo1.formData.taskState;
      loadingInstance.close();
    })
    .catch((err) => {
      loadingInstance.close();
    });
};

let isShow = route.query.flag && JSON.parse(route.query.flag);
let setIndex = ref(0);
let activeFn = (index) => {
  setIndex.value = index;
};
</script>

<style lang="scss" scoped>
.noData {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #888888;
    img {
      margin-bottom: 15px;
    }
  }
}
.clyj {
  width: 100%;
  margin-bottom: 38px;
  &_title {
    display: flex;
    align-items: center;
    font-size: 18px;
    color: #333;
    img {
      margin-left: 6px;
    }
  }
  &_con {
    width: 100%;
    height: 80px;
    background: #f4f8fb;
    border-radius: 4px;
    margin-top: 15px;
    margin-bottom: 14px;
    .el-col {
      text-align: center;
      line-height: 80px;

      .t {
        font-size: 14px;
        color: #888888;
      }
    }
  }
  .mes {
    width: 100%;
    height: 62px;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    padding: 15px 22px;
    box-sizing: border-box;
  }
}
.row {
  margin-bottom: 20px !important;
}
.active {
  background: #246aed;
  color: #fff !important;
}
.select {
  width: 100%;
  height: 120px;
  background: #f4f8fb;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
  li {
    padding: 8px 22px;
    box-sizing: border-box;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    color: #999999;
    font-size: 14px;
    &:hover {
      color: #6997ee;
      border: 1px solid #6997ee;
    }
  }
}
.el-form-item {
  align-items: center;
}
.detail {
  width: 100%;
  height: 100%;
  background-color: #ecf2f9;
  padding: 20px;
  box-sizing: border-box;
  .el-card {
    padding: 20px;
    box-sizing: border-box;
  }
}
table {
  width: 100%;
  height: 597px;
  border: 1px solid #f3f3f3;
  border-radius: 10px;
  margin-bottom: 30px;
}

.divitem {
  display: flex;

  border-bottom: 1px solid #f3f3f3;
}
.divitem div {
  min-height: 50px;

  // line-height: 50px;
  display: flex;
  align-items: center;
  // justify-content: center;
}
.divitem div:nth-child(2) {
  flex: 1;

  box-sizing: border-box;
  padding: 10px;
}
.divitem div:nth-child(4) {
  flex: 1;

  box-sizing: border-box;
  padding: 10px;
}
.title {
  width: 210px;
  background-color: #f4f8fb;
  font-size: 14px;
  // text-align: center;
  color: #888888;
  display: flex;
  align-items: center;
  justify-content: center;
}
.lc {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.left,
.right {
  width: 770px;
  height: 565px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  position: relative;
}
.left {
  background: url("../../assets/img/liuchenggenzong.png");
  position: relative;
  .img1 {
    position: absolute;
    top: 135px;
    right: 84px;
  }
  .img2 {
    position: absolute;
    top: 132px;
    left: 164px;
  }
  .img3 {
    position: absolute;
    top: 267px;
    right: 73px;
  }
  .img4 {
    position: absolute;
    bottom: 130px;
    left: 164px;
  }
}
.right {
  background: url("../../assets/img/liuchengtu.png");
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .el-card {
    height: 318px;
    width: 209px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    overflow: inherit;

    .jt {
      position: absolute;
      top: 133px;
      right: -31px;
      z-index: 111;
    }
  }
  ::v-deep .el-card__body {
    flex-direction: column;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.con {
  width: 414px;
  height: 70px;
  background: #f4f8fb;
  border-radius: 35px;
  text-align: center;
  line-height: 70px;
  color: #666666;
  font-size: 14px;
}
.con1 {
  position: absolute;
  top: 154px;
  left: 59px;
}
.con2 {
  position: absolute;
  top: 244px;
  right: 105px;
}
.con3 {
  position: absolute;
  bottom: 154px;
  left: 59px;
}
.flag {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-self: flex-end;
  margin-bottom: 40px;
  li {
    display: flex;
    align-items: center;
    img {
      margin-right: 14px;
    }
  }
}
.cardCon {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-row {
  display: flex;
  align-content: space-between;
  flex-wrap: nowrap;
}
::v-deep .el-radio__inner::after {
  width: 8px;
  height: 8px;
  border-radius: var(--el-radio-input-border-radius);
  background-color: var(--el-color-white);
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) scale(0);
  transition: transform 0.15s ease-in;
}
::v-deep .el-radio__input.is-checked .el-radio__inner {
  background-color: #2a51f2;
  border-color: #2a51f2;
}
::v-deep .el-radio__input.is-checked + .el-radio__label {
  color: #2a51f2;
}
::v-deep .el-radio__label {
  color: #666;
}

.elbtn {
  background-color: #246aed;
  color: #fff;
}
.return {
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 13px;
    height: 13px;
    margin-right: 11px;
  }
}
</style>
